import { render, staticRenderFns } from "./ItemsCount.vue?vue&type=template&id=23502935&"
import script from "./ItemsCount.vue?vue&type=script&lang=ts&"
export * from "./ItemsCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports